var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistrictHeating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.28 50.48H13.73",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6602 50.48C28.8502 50.48 26.82 50.48 26.01 50.48",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8201 50.49C40.6901 50.49 39.68 50.49 38.55 50.49",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8401 46.6C51.1001 46.6 56.25 46.6 56.51 46.6V50.48C56.17 50.48 51.1801 50.48 50.8401 50.48",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.55 46.6H41.9399",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.01 46.6C26.01 46.6 29.9501 46.6 29.6401 46.6",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.73 46.6H17.28",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84009 50.48H1.18994V46.6C1.85994 46.6 3.94011 46.6 4.61011 46.6",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0901 45.61H55.9302C55.5491 45.61 55.24 45.9189 55.24 46.3V50.79C55.24 51.1711 55.5491 51.48 55.9302 51.48H57.0901C57.4712 51.48 57.78 51.1711 57.78 50.79V46.3C57.78 45.9189 57.4712 45.61 57.0901 45.61Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.55 51.58C13.55 54.43 11.61 56.75 9.23999 56.75C6.86999 56.75 4.93018 54.42 4.93018 51.58V6.17C4.93018 3.32 6.86999 1 9.23999 1C11.61 1 13.55 3.33 13.55 6.17V51.58Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.55 51.58C13.55 54.43 11.61 56.75 9.23999 56.75C6.86999 56.75 4.93018 54.42 4.93018 51.58V6.17C4.93018 3.32 6.86999 1 9.23999 1C11.61 1 13.55 3.33 13.55 6.17V51.58Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9001 51.58C25.9001 54.43 23.9601 56.75 21.5901 56.75C19.2201 56.75 17.28 54.42 17.28 51.58V6.17C17.28 3.32 19.2201 1 21.5901 1C23.9601 1 25.9001 3.33 25.9001 6.17V51.58Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9001 51.58C25.9001 54.43 23.9601 56.75 21.5901 56.75C19.2201 56.75 17.28 54.42 17.28 51.58V6.17C17.28 3.32 19.2201 1 21.5901 1C23.9601 1 25.9001 3.33 25.9001 6.17V51.58Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.26 51.58C38.26 54.43 36.32 56.75 33.95 56.75C31.58 56.75 29.6401 54.42 29.6401 51.58V6.17C29.6401 3.32 31.58 1 33.95 1C36.32 1 38.26 3.33 38.26 6.17V51.58Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.26 51.58C38.26 54.43 36.32 56.75 33.95 56.75C31.58 56.75 29.6401 54.42 29.6401 51.58V6.17C29.6401 3.32 31.58 1 33.95 1C36.32 1 38.26 3.33 38.26 6.17V51.58Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6201 51.58C50.6201 54.43 48.6801 56.75 46.3101 56.75C43.9401 56.75 42 54.42 42 51.58V6.17C42 3.32 43.9401 1 46.3101 1C48.6801 1 50.6201 3.33 50.6201 6.17V51.58Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6201 51.58C50.6201 54.43 48.6801 56.75 46.3101 56.75C43.9401 56.75 42 54.42 42 51.58V6.17C42 3.32 43.9401 1 46.3101 1C48.6801 1 50.6201 3.33 50.6201 6.17V51.58Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3101 1V56.75",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.95 1V56.75",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5901 1V56.75",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23999 1V56.75",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 10.91H13.6501",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5801 10.91C28.7701 10.91 26.7402 10.91 25.9302 10.91",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.74 10.91C40.61 10.91 39.6 10.91 38.47 10.91",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.76 7.03C51.02 7.03 56.1702 7.03 56.4302 7.03V10.91C56.0902 10.91 51.1 10.91 50.76 10.91",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.47 7.03H41.8601",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9302 7.03C25.9302 7.03 29.8701 7.03 29.5601 7.03",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6501 7.03H17.2",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76001 10.91H1.11011V7.03C1.78011 7.03 3.86003 7.03 4.53003 7.03",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M57.01 6.03H55.8501C55.469 6.03 55.1602 6.33892 55.1602 6.72V11.21C55.1602 11.5911 55.469 11.9 55.8501 11.9H57.01C57.3911 11.9 57.7 11.5911 57.7 11.21V6.72C57.7 6.33892 57.3911 6.03 57.01 6.03Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistrictHeating);
export default __webpack_public_path__ + "static/media/districtHeating.14566790e400ef9894b22a323c60cd5d.svg";
export { ForwardRef as ReactComponent };